// extracted by mini-css-extract-plugin
export default {"toggleButtonContainer":"toggleButton_toggleButtonContainer__Y9XPB","toggleButton":"toggleButton_toggleButton__7Xdqm","customItem":"toggleButton_customItem__TSqu5"};